import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { FormatDate } from "utils/dateUtils";
import "../../../styles/print.scss";
import { selectState } from "../main.slice";
import { useSelector } from "react-redux";

const PrintResourcesCensus = () => {
  const memorandumLogo = useMemorandumLogo();
  const { resourcesCensus } = useSelector(selectState);

  return (
    <div className="resources-print">
      <div className="resources-print-header">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <span>
          <h1>Stanje resursa na dan: </h1>
          <div>{resourcesCensus && FormatDate(resourcesCensus.date)}</div>
        </span>
      </div>
      {resourcesCensus !== undefined && resourcesCensus.projects.map((project, projectIndex) => (
        <div className="resources-print-census-project-section">
          <div className="resources-print-census-project-name">{project.projectName}</div>
          <div className="resources-print-census-resources-list">
            {project.resources.map((resource, resourceIndex) => (
              <div className="resources-print-census-resource-item">
                ( ) <span className="resources-print-census-resource-name">{resource.resourceName}</span>
                &nbsp;:&nbsp;<span className="resources-print-census-resource-charged-by">{resource.chargedBy}</span>
                {resource.chargedQuantity !== undefined && (<span className="resources-print-census-resource-quantity">, {resource.chargedQuantity}kom</span>)}
                <span className="resources-print-census-resource-charge-date">, {FormatDate(resource.chargedOnDate)}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PrintResourcesCensus;
